import React from 'react';
import classnames from 'classnames';
import { Popover } from 'antd';
import Button from '@web-common/components/UI/Button';
import UnionIcon from '@/images/icons/edm/union-icon.svg';
import { OverflowShowTooltips } from '../../components/OverflowShowTooltips';
import styles from './MailTemplateListV2.module.scss';
export const PersonalCard = ({ templateInfo, cardOp, isFormWrite, tagInfo, isFromModal }) => {
    const opPopover = (templateType, tabId) => {
        if (templateType === 'PERSONAL' || tabId === 2) {
            return (React.createElement(Popover, { title: null, trigger: "click", getPopupContainer: node => node, placement: "topLeft", zIndex: 10, content: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.popoverContent },
                        React.createElement("div", { className: classnames(styles.popoverBtn), onClick: () => cardOp('edit', templateInfo.templateId) }, "\u7F16\u8F91"),
                        React.createElement("div", { className: classnames(styles.popoverBtn), onClick: () => cardOp('delete', templateInfo.templateId) }, "\u5220\u9664"))) },
                React.createElement("div", { className: styles.popoverWrap },
                    React.createElement("img", { src: UnionIcon, alt: "" }))));
        }
        if (templateType === 'COMMON' || tabId === 3) {
            return (React.createElement(Popover, { title: null, trigger: "click", getPopupContainer: node => node, placement: "topLeft", zIndex: 10, content: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.popoverContent },
                        React.createElement("div", { className: classnames(styles.popoverBtn), onClick: () => cardOp('saveTemplate', templateInfo.templateId) }, "\u4FDD\u5B58\u4E3A\u4E2A\u4EBA\u6A21\u677F"))) },
                React.createElement("div", { className: styles.popoverWrap },
                    React.createElement("img", { src: UnionIcon, alt: "" }))));
        }
        return null;
    };
    const renderTag = () => {
        if (templateInfo.templateType === 'COMMON') {
            if (tagInfo) {
                return React.createElement("div", { className: classnames(styles.tag, styles.ellipsis) }, tagInfo);
            }
            if (templateInfo.tagList != null && templateInfo.tagList.length > 0) {
                return React.createElement("div", { className: classnames(styles.tag, styles.ellipsis) }, templateInfo.tagList[0].tagName);
            }
        }
        return null;
    };
    return (React.createElement("div", { className: classnames(styles.taskItem) },
        React.createElement("div", { className: classnames(styles.taskCard, isFormWrite ? styles.taskCardMin : '', styles.recommendCard) },
            renderTag(),
            React.createElement("div", { className: classnames(styles.taskCardTitle, styles.ellipsis) }, templateInfo.templateName),
            React.createElement("div", { className: classnames(styles.taskCardImg, styles.taskCardImg1), onClick: () => cardOp('display', templateInfo.templateId) },
                templateInfo.templateContentType === 1 && templateInfo.templateDesc && (React.createElement("div", { className: styles.imgInfo },
                    React.createElement(OverflowShowTooltips, { className: styles.infoText, value: templateInfo.templateDesc }))),
                React.createElement("img", { src: templateInfo.thumbnail.newUrl || templateInfo.thumbnail.url, alt: "" })),
            React.createElement("div", { className: styles.labels },
                templateInfo.openRate != null && React.createElement("div", { className: styles.labelItem },
                    "\u6253\u5F00\u7387: ",
                    templateInfo.openRate),
                templateInfo.replyRate != null && React.createElement("div", { className: styles.labelItem },
                    "\u56DE\u590D\u7387: ",
                    templateInfo.replyRate)),
            React.createElement("div", { className: classnames(styles.cardOp, isFormWrite ? styles.cardOpMin : '', isFromModal ? styles.cardOpSingle : '') },
                !isFromModal && opPopover(templateInfo.templateType, templateInfo.tabId),
                isFromModal ? (React.createElement(Button, { className: classnames(styles.templateBtn, styles.templateBtn2), style: {
                        width: 74,
                        height: 28,
                    }, btnType: "primary", onClick: () => cardOp('useAsRecommend', templateInfo.templateId) }, "\u4F7F\u7528")) : (React.createElement(React.Fragment, null,
                    React.createElement(Button, { className: styles.templateBtn, style: {
                            width: 74,
                            height: 28,
                        }, onClick: () => cardOp('display', templateInfo.templateId), btnType: "minorLine" }, "\u67E5\u770B"),
                    React.createElement(Button, { className: styles.templateBtn, style: {
                            width: 74,
                            height: 28,
                        }, btnType: "primary", onClick: () => cardOp('use', templateInfo.templateId) }, "\u4F7F\u7528")))))));
};
